import { useField } from "formik";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ICkEditorFieldProps } from "../../types";
import "./ckEditor.scss";

const CkEditorField = ({
  label,
  labelClassName = "",
  ...props
}: ICkEditorFieldProps) => {
  const [field, meta, helpers] = useField(props.name);

  return (
    <div style={{ marginBottom: "1rem" }}>
      {label && <label className={labelClassName}>{label}</label>}
      <CKEditor
        config={{
          image: {
            resizeUnit: "%",
            resizeOptions: [], // no resizing options
            toolbar: [], // remove image toolbar
          },
        }}
        editor={ClassicEditor}
        data={field.value}
        onChange={(event: any, editor: any) => {
          const data = editor.getData();
          helpers.setValue(data);
        }}
        onBlur={() => helpers.setTouched(true)}
      />
      {meta.touched && meta.error && (
        <div style={{ color: "red", fontSize: "0.8rem" }}>{meta.error}</div>
      )}
    </div>
  );
};

export default CkEditorField;
